/**
 * Mini-Game 페이지 팀별 Config
 *
 * 각 팀의 게임 색상과 배경색 설정
 */

import type { TeamSlug } from '@/app/(football)/[team]/_context/types';
import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

import { bluewingsConfig } from './bluewings';
import { dhcfcConfig } from './dhcfc';
import { fcanyangConfig } from './fcanyang';
import { fcseoulConfig } from './fcseoul';
import { jbfcConfig } from './jbfc';
import { steelersConfig } from './steelers';
import { uhdfcConfig } from './uhdfc';

export const miniGamePageConfig: Record<TeamSlug, MiniGamePageConfig> = {
  fcseoul: fcseoulConfig,
  bluewings: bluewingsConfig,
  steelers: steelersConfig,
  fcanyang: fcanyangConfig,
  uhdfc: uhdfcConfig,
  dhcfc: dhcfcConfig,
  jbfc: jbfcConfig,
};
